import { useMutation } from '@connectrpc/connect-query'
import { approveBiddingSpotApprovalRequests } from '@ebalance/proto/bffuser/v1/bidding_spot_service-BiddingSpotService_connectquery'

import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * スポット入札 (通常入札) のまとめて承認 mutation hook (AC-BSP-118)。
 *
 * 他の書込 hook (`useInvalidatingMutation`) と違い、 成功時の invalidate を持たない。 成功でも
 * RPC error でも一覧を読み直す必要があるため、 呼び出し側 (`useBulkApprovalFlow`) が行う。
 */
export const useApproveBiddingSpotApprovalRequests =
  (): InvalidatingMutationResultFor<
    typeof approveBiddingSpotApprovalRequests
  > =>
    useWorkflowCaseScopedMutation(
      useMutation(approveBiddingSpotApprovalRequests),
    )
